import { render } from "./auth-mfa.vue?vue&type=template&id=07596004&scoped=true"
import script from "./auth-mfa.vue?vue&type=script&lang=js"
export * from "./auth-mfa.vue?vue&type=script&lang=js"

import "./auth-mfa.vue?vue&type=style&index=0&id=07596004&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07596004"]])

export default __exports__